<template>
  <div class="drawer-con">
  <el-drawer
  class="drawer"
  :visible.sync="isActive"
  :direction="direction"
  :show-close="false"
  :withHeader="false"
  @close="waffleClose">
  <ul id="pro_nav" class="nav-menu scrollAuto">
    <li class="left">
        <a :href="`https://userservice.tvunetworks.com/user-group/?userId=${this.userId}&session=${this.session}&mark=group_user_detail_info#/ug`"  class="middle pro_li user_management" title="User Profile" target="_blank">
            <span class="pro_icon User-Profile"><img class="remove" :src="require('@/assets/img/User-Profile.png')" /></span>
            <span class="pro_name ellipsis">User Profile</span>
        </a>
    </li>
    <li class="left" v-for="item in waffleMenuItems" :key="item.serviceId">
        <a :href=item.url :title=item.serviceName target="_blank">
        <span class="icon-con"> 
        <img class="remove" :src="`https://userservice.tvunetworks.com/serviceListUI/package.serviceList/images/${getImgUrl(item.iconName)}`"/>
        </span>
        <label class="title-name">{{item.serviceName}}</label>
        </a>
    </li>
</ul>

</el-drawer>
  </div>
</template>
<script>
import Tool from '@/assets/js/common/utils.js';
import {
  waffleMenu, userInfoForWaffleMenu
} from '@/Api/files.js';
import { mapState } from 'vuex';
export default {
  name: "Waffle",
  data() {
    return {
      drawer: false,
      direction: 'rtl',
      waffleMenuItems: [],
      session: null,
      userUrl: null,
      userId: null,
      isActive: false
    };
  },
  computed: {
    ...mapState({
      wafflemenuStatus: (state) => state.wafflemenuStatus,
    }),
  },
  watch: {
    wafflemenuStatus() {
      if (this.wafflemenuStatus === true) {
        this.loadWaffleMenuItems()
      } else {
        this.isActive = false
      }
    }
  },
  methods: {
    getImgUrl(pic) {
      if (pic === 'drive' || pic === 'producer') {
        pic = 'Default Service'
      }
      let imgUrl = pic.replaceAll(" ", "-")+ '.png'
      return imgUrl
    },
    waffleClose() {
      this.$store.dispatch("commitisWaffleMenu", false);
    },
    async loadWaffleMenuItems() {
      this.session = Tool.getCookie()
      const getMenu = await waffleMenu(this.session);
      if (getMenu.data.errorCode == '0x0') {
        this.waffleMenuItems = getMenu.data.result;
        this.isActive = true
      }
      const userInfoForMenu = await userInfoForWaffleMenu(this.session);
      if (userInfoForMenu.data.errorCode == '0x0') {
        this.userId = userInfoForMenu.data.result.id;
        console.log('userIduserId', this.userId)
      }
    }
  }
};
</script>
<style lang="less">

.drawer{
.el-drawer__container{
  .el-drawer{
    max-width: 620px;
    width:620px!important;
    box-shadow: -2px 4px 12px #000;
    background-color: #282A2B;
    height: calc(100% - 64px);
    top: 64px;
  }
  }
  }

.drawer-con{
  margin:0;
  padding:0;
  .nav-menu{
    list-style: none;
    padding: 30px 50px;
    overflow-y: hidden;
    overflow: auto;
    box-sizing: content-box;
    margin: 0;
    list-style:none;
    display: flex;
    flex-wrap: wrap;
    max-height: 500px;
      li{ 
        margin: 0;
        padding: 0;
        display: flex;
        width: 32%;
        height: 120px;
        align-items: center;
        justify-content: center;
        flex-direction: row;
        a{
          margin: 0;
          padding: 0;
          display: flex;
          color: #fff;
          text-decoration: none;
          flex-direction: column;
          align-items: center;
          font-size: 14px;
          border: 1px solid #282A2B;
          height: 100%;
          width: 100%;
          justify-content: center;
        }
          a:hover{
           border: 1px solid #fff;
          }
      }
  }
}




.scrollAuto {
    overflow-y: auto;
}

.scrollAuto::-webkit-scrollbar  {
    background: #282A2B;
    width: 5px;
}


.scrollAuto::-webkit-scrollbar-thumb {
    background: #acacac;
    width: 5px;
    border-radius: 3px;
}

.scrollAuto.white::-webkit-scrollbar  {
    background: #fff;
    width: 5px;
}


.scrollAuto.white::-webkit-scrollbar-thumb {
    background: #ccc;
    width: 5px;
    border-radius: 3px;
}

.header-right{
  display:flex;
}
.v-modal {
  opacity: 0 !important;
}
</style>
